export const LOGIN_AUDIENCES = ["staff", "family", "resident"] as const;
export type LoginAudience = (typeof LOGIN_AUDIENCES)[number];

interface AudienceWords {
  hint: string | null;
  help: string | null;
}

/** Everyone signs in on the same form and lands by their role. A link from a family or resident
 * page can still say who is coming, which only adds a line of help. */
export const AUDIENCE_WORDS: Record<LoginAudience, AudienceWords> = {
  staff: { hint: null, help: null },
  family: {
    hint: "Use the email and password you chose when you accepted your invitation.",
    help: "Have an invitation? Open the link in your email.",
  },
  resident: {
    hint: "Use the username and password your community gave you.",
    help: "Need help signing in? Ask the front desk.",
  },
};
